import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'brand' | 'system';

export type ColorTheme =
  | 'kiboBlue'
  | 'kiboBrand'
  | 'chateauGreen'
  | 'tomatoOrange'
  | 'arcticBlue'
  | 'amethystPurple'
  | 'rosePink';

export const COLOR_THEMES: { value: ColorTheme; label: string; swatch: string }[] = [
  { value: 'kiboBlue', label: 'BlueB Blue', swatch: 'hsl(217, 91%, 60%)' },
  { value: 'kiboBrand', label: 'BlueB Brand', swatch: 'hsl(199, 89%, 48%)' },
  { value: 'chateauGreen', label: 'Chateau Green', swatch: 'hsl(145, 77%, 40%)' },
  { value: 'tomatoOrange', label: 'Tomato Orange', swatch: 'hsl(14, 100%, 64%)' },
  { value: 'arcticBlue', label: 'Arctic Blue', swatch: 'hsl(191, 100%, 56%)' },
  { value: 'amethystPurple', label: 'Amethyst Purple', swatch: 'hsl(271, 65%, 54%)' },
  { value: 'rosePink', label: 'Rose Pink', swatch: '#ff465a' },
];

interface ThemeState {
  theme: Theme;
  colorTheme: ColorTheme;
  setTheme: (theme: Theme) => void;
  setColorTheme: (color: ColorTheme) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'dark',
      colorTheme: 'kiboBlue',
      setTheme: (theme) => set({ theme }),
      setColorTheme: (colorTheme) => set({ colorTheme }),
    }),
    {
      name: 'kibo-theme-storage',
      // bump if we ever need a migration; for now, missing colorTheme falls back to default.
      version: 2,
    },
  ),
);
